import * as ltjsEnvironment from '../ltjsEnvironment';
import CursorManager from '../input/CursorManager';
import CursorChangeEvent from '../input/CursorChangeEvent';
var CURSOR_MAP = [
    '',
    '',
    'crosshair',
    'pointer',
    'help',
    'text',
    'none',
    'url(\'data:image/svg+xml;utf8,<svg version="1.1" id="pencilCursor" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="14px" height="14px" viewBox="0 0 14 14" enable-background="new 0 0 14 14" xml:space="preserve"><path id="cursorOutline" fill="rgb(256,256,256)" d="M13.423,4.749l-7.51,7.517C5.913,12.266,1.399,14,1,14c-0.361,0-0.517-0.103-0.708-0.293 c-0.268-0.269-0.36-0.665-0.24-1.024l1.689-4.587l7.512-7.518C9.625,0.205,10.121,0,10.649,0s1.024,0.205,1.396,0.577l1.378,1.379 C14.193,2.727,14.192,3.979,13.423,4.749z"/><path id="cursorColor" d="M4.708,11.769L1,13l1.238-3.701L4.708,11.769z M11.43,5.329l1.286-1.287c0.379-0.379,0.379-1,0-1.379 l-1.378-1.379c-0.379-0.379-0.999-0.379-1.378,0L8.673,2.573L11.43,5.329z M7.613,3.634L3.155,8.095l2.757,2.757L10.37,6.39 L7.613,3.634z"/></svg>\') 0 14, pointer',
    'all-scroll',
    'e-resize',
    'n-resize',
    'ne-resize',
    'ns-resize',
    'nw-resize',
    's-resize',
    'se-resize',
    'sw-resize',
    'w-resize',
    'ew-resize',
    'move',
    'nesw-resize',
    'ns-resize',
    'nwse-resize',
    'ew-resize',
    'n-resize',
    'wait',
];
var CursorHelper = {
    checkCursor: function () {
        var cursor = CURSOR_MAP[CursorManager.getCursorShape()];
        document.body.style.cursor = cursor;
    },
};
ltjsEnvironment.runWhenInitialized(function () {
    // TODO: I have used ! because I know the shared instance can never be null.
    // I think the only way to handle this is model these semantics in the portable types.
    var cursorManager = CursorManager.getSharedInstance();
    // NOTE(mikcol): legacy passes `this` as the 3rd argument, not sure what it is in this context
    // NOTE(mikcol)| it shouldn't be needed though.
    cursorManager.attachEvent(CursorChangeEvent.CURSOR_CHANGE, function (event) {
        if (event instanceof CursorChangeEvent) {
            var cursor = event.getCursorShape();
            document.body.style.cursor = CURSOR_MAP[cursor];
        }
    });
});
export default CursorHelper;
